var Cart = {
    init: function () {
        $(document)
            .on('change', '.js-payment-radios input[type="radio"]', Cart.showMoveToQuoteListButton)
            .on('keypress', '.jsChangeCartItem', Cart.preventSubmit)
            .on('click', '#jsMoveToQuoteListButton', Cart.moveAllToQuoteList)
            .on('click', '.jsRemoveCartItem', Cart.removeCartItem)
            .on('click', '.jsMoveToCart', Cart.moveToCart)
            .on('click', '.jsMoveToQuoteList', Cart.moveToQuoteList)
            .on('change', '.jsChangeCartItem', Cart.changeCartItem)
            .on('keyup', '.jsChangeCartItem', Cart.changeCartItemOnEnter)
            .on('change', '.jsChangeShipment', Cart.changeShipment)
            .on('click', '.jsAddToCart', Cart.addCartItem)
            .on('click', '.jsAddSparePart', Cart.addSparePart)
            .on('submit', 'form.jsCheckoutForm', Cart.checkForm)
            .on('change',
                '#MiniCart',
                function () { $("#MiniCartResponsive > div:first").html($("div:first", this).html()); })
            .on('change',
                '#QuoteListMiniCart',
                function () { $("#QuoteListMiniCartResponsive > div:first").html($("div:first", this).html()); })
            .on('click',
                '.jsCartContinueShopping',
                function () {
                    if ($(this).closest('#cart-dropdown')) {
                        $(this).closest('#cart-dropdown').collapse('hide');
                    }
                })
            .on('click',
                '.jsQuoteListContinueShopping',
                function () {
                    if ($(this).closest('#quotelist-dropdown')) {
                        $(this).closest('#quotelist-dropdown').collapse('hide');
                    }
                })
            .on('click',
                '.jsCartDropdown',
                function (e) {
                    return ($(e.target).hasClass('btn') || $(e.target).parent().is('a'));
                })
            .on('click',
                '.js-show-spinner-cart',
                function () {
                    var formQL = $(".js-show-spinner-cart").closest("form");
                    formQL.validate();
                    if (formQL.valid()) {
                        //$(".js-show-spinner").addClass("show-spinner");
                        //$(".js-show-spinner-cart").addClass("hidden");
                        $('body').prepend('<div class="js-invoice-spinner invoice-spinner fullpage"><img alt="loading-icon" src="/gear-spinner-darker.svg" class="expected-delivery-img"></div>');
                        setTimeout(function () {
                            //$(".js-show-spinner").removeClass("show-spinner");
                            //$(".js-show-spinner-cart").removeClass("hidden");
                            $(".js-invoice-spinner").remove();
                        }, 180000);
                    }
                });
        Cart.changeCartItem();

        $('.cart-dropdown').on('show.bs.dropdown', function (e) {
            if ($('#CartItemCount', $(this)).val() === 0) {
                e.preventDefault();
            }
        });

    },
    changeShipment: function () {
        var container = $(this).closest('.shipping-method');
        var url = container.data('url');
        $.ajax({
            type: "POST",
            url: url,
            cache: false,
            success: function (result) {
                Checkout.updateOrderSummary();
            }
        });
    },
    changeCartItemOnEnter: function (e) {
        e.preventDefault();
        if (e.keyCode == 13) {
            $(".jsChangeCartItem").blur();
        }
    },
    changeCartItem: function (e) {
        var triggered;
        if (e) {
            e.preventDefault();
            triggered = true; 
        }
        var form = $(this).closest("form");
        //var quantity = $("#quantity", form).val();
        if (triggered) {
            var containerName = form.data("container");
            if (containerName == "MiniCart") {
                $(".js-mini-cart-updating").addClass("active");
            } else {
                $(".js-mini-quote-cart-updating").addClass("active");
            }
            Cart.disableLargeCart();
        }
        var quantity = 10;

        if (parseInt(quantity, 10) < 0) {
            return;
        }

        var formContainer = $("#" + form.data("container"));
        if (form[0] == undefined) {
            return;
        }
        $.ajax({
            type: "POST",
            url: form[0].action + "?lang=" + $('html').attr('lang'),
            data: form.serialize(),
            success: function (result) {

                formContainer.html($(result));
                $('.cartItemCountLabel', formContainer.parent()).text($('#CartItemCount', formContainer).val());

                if (formContainer.is($('#QuoteListMiniCart'))) {
                    $('.qcMobile .cartItemCountLabel').text($('#CartItemCount', formContainer).val());
                    $('#QuoteListMiniCartResponsive').html($(result));
                    if (result.indexOf('list-group-item') === -1) {
                        $('.delete-quotelist').hide();
                    }
                    var quoteListAction = form.closest(".quotelist-actions");
                    if (quoteListAction.length > 0) {
                        quoteListAction.parent().remove();
                    }
                }
                else if (formContainer.is($('#MiniCart'))) {
                    $('.scMobile .cartItemCountLabel').text($('#CartItemCount', formContainer).val());
                    $('#MiniCartResponsive').html($(result));
                }
                //var checkoutView = document.getElementById("CheckoutView");
                //if (checkoutView) {
                //    setTimeout(function () {
                //        appAXFLOW.recheckAvailabilityDateCheckout();
                //    },
                //        4000);
                //}
            }
        });
        //if quotepage, trigger reload for captcha
        if ($(".quote-list-page")[0]) {

            setTimeout(function () {
                window.top.location.href = window.top.location.href;
            },
                2000);
        }

    },
    removeCartItem: function (e) {
        e.preventDefault();
        var form = $(this).closest('form');
        var containerName = form.data("container");
        if (containerName == "MiniCart") {
            $(".js-mini-cart-updating").addClass("active");
        } else {
            $(".js-mini-quote-cart-updating").addClass("active");
        }

        $("#quantity", form).val(0).change();
        //$(this).closest(".jsProductTile").remove();
        if (!$(".cart-row").length) {
            $(".quotelist-noitem").show();
        }
        Cart.disableLargeCart();
    },
    moveToCart: function (e) {
        e.preventDefault();
        var form = $(this).closest('form');
        var quantity1 = $("#quantity", form).val();
        var code1 = $("#code", form).val();
        $(".js-mini-quote-cart-updating").addClass("active");
        Cart.disableLargeCart();
 
        $.ajax({
            type: "POST",
            url: "/QuoteList/MoveToCart",
            data: { code: code1, quantity: quantity1, lang: $('html').attr('lang') },
            success: function (result) {
                $("#quantity", form).val(0).change();
                var formContainer = $("#MiniCart");
                formContainer.html($(result));
                var counterEl = $('.cartItemCountLabel', formContainer.parent());
                counterEl.text($('#CartItemCount', formContainer).val());
                var formContainerQ = $("#MiniCartResponsive");
                formContainerQ.html($(result));
                $('.cartItemCountLabel', formContainerQ.parent()).text($('#CartItemCount', formContainerQ).val());
                //formContainer.change();
                Cart.checkAmount();
                console.log("success");
            },
            error: function (xhr, status, error) {
                alert(xhr.statusText);
            }
        });
    },
    showMoveToQuoteListButton: function () {
        if ($(this).is(':checked') && ($(this).attr('id') == "jsMoveToQuoteListCheckBox")) {
            $("#jsMoveToQuoteListButton").show();
            $(".js-payment-button").hide();

        } else {
            $("#jsMoveToQuoteListButton").hide();
            $(".js-payment-button").show();
        }
    },
    moveAllToQuoteList: function (e) {
        e.preventDefault();
        Cart.disableLargeCart();
        $.ajax({
            type: "POST",
            url: "/QuoteList/MoveAllToQuoteList",
            data: { lang: $('html').attr('lang') },
            success: function (result) {
                console.log("success");
                window.top.location.href = result;
            },
            error: function (xhr, status, error) {
                alert(xhr.statusText);
            }
        });

    },
    moveToQuoteList: function (e) {
        e.preventDefault();
        var form = $(this).closest('form');
        var quantity1 = $("#quantity", form).val();
        var code1 = $("#code", form).val();
        $(".js-mini-cart-updating").addClass("active");
        Cart.disableLargeCart();
        $.ajax({
            type: "POST",
            url: "/QuoteList/MoveToQuoteList",
            data: { code: code1, quantity: quantity1, lang: $('html').attr('lang') },
            success: function (result) {
                var formContainer = $("#QuoteListMiniCart");

                formContainer.html($(result));
                var counterEl = $('.cartItemCountLabel', formContainer.parent());
                counterEl.text($('#CartItemCount', formContainer).val());
                
                var formContainerQ = $("#QuoteListMiniCartResponsive");
                formContainerQ.html($(result));
                $('.cartItemCountLabel', formContainerQ.parent()).text($('#CartItemCount', formContainerQ).val());
                //formContainer.change();
                Cart.checkAmount();
                console.log("success");
                $("#quantity", form).val(0).change();
            },
            error: function (xhr, status, error) {
                alert(xhr.statusText);
            }
        });
    },
    checkAmount: function () {
        var cartCounterEl = $('.shop-cart .cartItemCountLabel');
        var quoteCounterEl = $('.quote-cart .cartItemCountLabel');
        var quoteAmount = $("#QuoteListMiniCart #CartItemCount").val();
        var cartAmount = $("#MiniCart #CartItemCount").val();

        showHide(cartCounterEl, quoteAmount);
        showHide(quoteCounterEl, cartAmount);


        function showHide(el, n) {
            if (n > 0) {
                el.removeClass("hidden");
            }
        }

    },
    disableLargeCart: function () {
        var onCheckoutPageEl = $(".single-shipment-checkout");
        var onQuoteListPageEl = $(".quote-list-page");
        if (onCheckoutPageEl.length > 0) {
            $(".js-cart-updating").addClass("active");

        }
        if (onQuoteListPageEl.length > 0) {
            $(".js-cart-updating").addClass("active");
        }
    },

    addCartItem: function (e) {
        e.preventDefault();
        var form = $(this).closest("form");
        var formAction;
        var containerName = $(this).data("container");
       

        if ($("body").hasClass("non-axflow-country-visitor")) {
            $(this).siblings(".js-language-selector-helper").removeClass("hidden");
        }

        if (containerName == "MiniCart")
            formAction = "/Cart/AddToCart";
        else
            formAction = "/QuoteList/AddToCart";
        var formContainer = $("#" + containerName);
        //remove hidden to show small counter
        $(".cartItemCountLabel", formContainer.parent()).removeClass("hidden");
        var skuCode = $("#code", form).val();
        if (skuCode == "" || skuCode == null) {
            alert("Please, select some product variant");
            return;
        }
        if (containerName == "MiniCart") {
            var skuText = $("#code option:selected", form).text();
            var patt = / \-.+\d+/;
            if (!patt.test(skuText)) {
                alert("Sorry, product variant does not have defined price");
                return;
            }
        }

        //Check in the quote or buy button is in the popup of the exploaded view
        var explodedSelector = "";

        if ($(this).hasClass('js-exploded-button')){
            explodedSelector = ".js-exploded-modal-right-col ";
        }
        
        $.ajax({
            type: "POST",
            url: formAction + "?lang=" + $('html').attr('lang'),
            data: { code: skuCode, quantity: $(explodedSelector +"#quantityQ").val() },
            //data: { code: skuCode, quantity: closestQuantity },
            success: function (result) {
                formContainer.html($(result));
                $('.cartItemCountLabel', formContainer.parent()).text($('#CartItemCount', formContainer).val());
                formContainer.change();
                if (containerName == "QuoteListMiniCart") {
                    var formContainerQ = $("#QuoteListMiniCartResponsive");
                    formContainerQ.html($(result));
                    $('.cartItemCountLabel', formContainerQ.parent()).text($('#CartItemCount', formContainerQ).val());
                    formContainerQ.parent().addClass("open");
                    $(".cartItemCountLabel", formContainerQ.parent()).removeClass("hidden");
                }
                else if (containerName == "MiniCart") {
                    var formContainerM = $("#MiniCartResponsive");
                    formContainerM.html($(result));
                    $('.cartItemCountLabel', formContainerM.parent()).text($('#CartItemCount', formContainerM).val());
                    formContainerM.parent().addClass("open");
                    $(".cartItemCountLabel", formContainerM.parent()).removeClass("hidden");
                }
                //Toggle cart open for visual happening
                formContainer.parent().addClass("open");
            },
            error: function (xhr, status, error) {
                alert(xhr.statusText);
            }
        });
    },
    addSparePart: function (e) {
        e.preventDefault();
        $(".cartItemCountLabel").removeClass("hidden");
        var parentDiv = $(this).parent();
        var formAction;
        var containerName = $(this).data("container");
        if (containerName == "MiniCart")
            formAction = "/Cart/AddToCart";
        else
            formAction = "/QuoteList/AddToCart";
        var formContainer = $("#" + containerName);
        $.ajax({
            type: "POST",
            url: formAction + "?lang=" + $('html').attr('lang'),
            data: { code: $(".code", parentDiv).val(), quantity: $(".quantity", parentDiv).val() },
            success: function (result) {
                formContainer.html($(result));
                $('.cartItemCountLabel', formContainer.parent()).text($('#CartItemCount', formContainer).val());
                formContainer.change();
                if (containerName == "QuoteListMiniCart") {
                    var formContainerQ = $("#QuoteListMiniCartResponsive");
                    formContainerQ.html($(result));
                    $('.cartItemCountLabel', formContainerQ.parent()).text($('#CartItemCount', formContainerQ).val());
                    formContainerQ.parent().addClass("open");
                }
                else if (containerName == "MiniCart") {
                    var formContainerM = $("#MiniCartResponsive");
                    formContainerM.html($(result));
                    $('.cartItemCountLabel', formContainerM.parent()).text($('#CartItemCount', formContainerM).val());
                    formContainerM.parent().addClass("open");
                }
                formContainer.parent().addClass("open");
            },
            error: function (xhr, status, error) {
                alert(xhr.statusText);
            }
        });
    },
    preventSubmit: function (e) {
        if (e.keyCode === 13) {
            e.preventDefault();
        }
    },
    checkForm: function (e) {
        var pay_Invoice = $("input[id='pay_Invoice']:checked");
        var addtionalInformation = "";
        $(".js-AdditionalItemInformationItem").each(function (index) {
            //addtionalInformation = addtionalInformation + $(this).val().replaceAll('"', "") + "*~*~";
            addtionalInformation = addtionalInformation + $(this).val() + "*~*~";
        });
        $(".js-AdditionalItemInformation").val(addtionalInformation);
        
        if (pay_Invoice.length == 1 && $("input[name='FakturaAddressId']").length > 0 &&
            $("input[name='FakturaAddressId']:checked").length == 0) {
            e.preventDefault();
            $(".fakturaReq").show();
            $(".fakturaReq").focus();
        }
        else {
            $(".fakturaReq").hide();
            $('body').prepend('<div class="js-invoice-spinner invoice-spinner fullpage"><img alt="loading-icon" src="/gear-spinner-darker.svg" class="expected-delivery-img"></div>');
        }

    }

};

//fetch QUOTE cart once page is loaded
var form = $(".sticky-form");
var formContainer = $("#QuoteListMiniCart");
var containerName = "QuoteListMiniCart";
$.ajax({
    type: "GET",
    //url:"QuoteList/AddToCart?lang=de-DE",
    url: "/QuoteList/GetCart?lang=" + $('html').attr('lang') + "&" + new Date().getTime(),
    //data: { code: 20734, quantity: 1},
    success: function (result) {
        formContainer.html($(result));
        $('.cartItemCountLabel', formContainer.parent()).text($('#CartItemCount', formContainer).val());
        //formContainer.change();
        if (containerName == "QuoteListMiniCart") {
            var formContainerQ = $("#QuoteListMiniCartResponsive");
            formContainerQ.html($(result));

            if ($('#QuoteListMiniCart #CartItemCount').val() > 0) {
                $('.cartItemCountLabel', formContainerQ.parent()).text($('#CartItemCount', formContainerQ).val());
                $(".cartItemCountLabel", formContainerQ.parent()).removeClass("hidden");
                $('.quote-cart .cartItemCountLabel').removeClass("hidden");
            } else {
                $(".cartItemCountLabel", formContainerQ.parent()).addClass("hidden");
            }

        }
        //else if (containerName == "MiniCart") {
        //    var formContainerM = $("#MiniCartResponsive");
        //    formContainerM.html($(result));
        //    $('.cartItemCountLabel', formContainerM.parent()).text($('#CartItemCount', formContainerM).val());
        //    formContainerM.parent().addClass("open");
        //    $(".cartItemCountLabel", formContainerM.parent()).removeClass("hidden");
        //}
        //Toggle cart open for visual happening
        //but dont do this for the first ajax call
        //formContainer.parent().addClass("open");
    },
    error: function (xhr, status, error) {
        console.log(xhr.statusText);
    }
});

//Fetch shopping cart every pageload


var formCart = $(".sticky-form");
var formContainerCart = $("#MiniCart");
var containerNameCart = "MiniCart";
$.ajax({
    type: "GET",
    //url:"QuoteList/AddToCart?lang=de-DE",
    url: "/Cart/GetCart?lang=" + $('html').attr('lang') + "&" + new Date().getTime(),
    //data: { code: 20734, quantity: 1},
    success: function (result) {
        formContainerCart.html($(result));
        $('.cartItemCountLabel', formContainerCart.parent()).text($('#CartItemCount', formContainerCart).val());
        //formContainerCart.change();
        if (containerNameCart == "MiniCart") {
            var formContainerQ = $("#MiniCartResponsive");
            formContainerQ.html($(result));

            if ($('#MiniCart #CartItemCount').val() > 0) {
                $('.cartItemCountLabel', formContainerQ.parent()).text($('#CartItemCount', formContainerQ).val());
                $(".cartItemCountLabel", formContainerQ.parent()).removeClass("hidden");
                $('.shop-cart .cartItemCountLabel').removeClass("hidden");
            } else {
                $(".cartItemCountLabel", formContainerQ.parent()).addClass("hidden");
            }

        }
    },
    error: function (xhr, status, error) {
        console.log(xhr.statusText);
    }
});
